import { createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'
import ComplianceReminderApi from '../../middleware/api/Dashboard/upComingComplianceApi'
import { AppDispatch, RootState } from '../../stateStore'
import { LoadingState, ValidationError } from '../../types/commonTypes'
import {
  UpcomingComplianceItem,
  UpComingComplianceSliceState,
} from '../../types/ComplianceReminder/ComplianceReminderType'
import { ApiLoadingState } from '../../middleware/api/apiList'

const getUpcomingComplianceDueDates = createAsyncThunk<
  UpcomingComplianceItem[],
  void,
  {
    dispatch: AppDispatch
    state: RootState
    rejectValue: ValidationError
  }
>('/compliance/getUpcomingComplianceDueDates', async (_, thunkApi) => {
  try {
    return await ComplianceReminderApi.getUpcomingComplianceDueDates()
  } catch (error) {
    const err = error as AxiosError
    return thunkApi.rejectWithValue(err.response?.status as ValidationError)
  }
})

const initialUpComingComplianceState: UpComingComplianceSliceState = {
  isLoading: ApiLoadingState.idle,
  error: null,
  upcomingCompliance: [],
}

const upcomingComplianceSlice = createSlice({
  name: 'upcomingCompliance',
  initialState: initialUpComingComplianceState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUpcomingComplianceDueDates.fulfilled, (state, action) => {
        state.isLoading = ApiLoadingState.succeeded
        state.upcomingCompliance = action.payload as UpcomingComplianceItem[]
      })
      .addCase(getUpcomingComplianceDueDates.rejected, (state) => {
        state.isLoading = ApiLoadingState.failed
      })
      .addMatcher(isAnyOf(getUpcomingComplianceDueDates.pending), (state) => {
        state.isLoading = ApiLoadingState.loading
      })
  },
})

const UpcomingComplianceThunk = {
  getUpcomingComplianceDueDates,
}

const upcomingCompliance = (state: RootState): UpcomingComplianceItem[] =>
  state.upcomingCompliance.upcomingCompliance

const isLoading = (state: RootState): LoadingState =>
  state.upcomingCompliance.isLoading
const upcomingComplianceSelectors = {
  isLoading,
  upcomingCompliance,
}

export const upcomingComplianceService = {
  ...UpcomingComplianceThunk,
  actions: upcomingComplianceSlice.actions,
  selectors: upcomingComplianceSelectors,
}

export default upcomingComplianceSlice.reducer
